<template>
    <div class="cctv-container">
      <div v-if="streamUrls.length">
        <iframe 
          v-for="(url, index) in streamUrls" 
          :key="index" 
          :src="url" 
          frameborder="0" 
          allowfullscreen 
          class="cctv-frame"
        ></iframe>
      </div>
      <p v-else>No CCTV Stream Available</p>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      streamUrl: {
        type: String,
        required: true
      }
    },
    computed: {
      streamUrls() {
        return this.streamUrl.split(',');
      }
    }
  };
  </script>
  
  <style scoped>
  .cctv-container {
  width: 100%;
  max-width: 100%;
  margin: auto;
  text-align: center;
  overflow: hidden;
}

.cctv-grid {
  display: flex;
  gap: 1px;
  justify-content: center;
  flex-wrap: nowrap; /* Prevents wrapping that might cause overflow */
  width: 150%;
  overflow-x: auto; /* Allows horizontal scrolling if needed */
  scrollbar-width: none; /* Hides scrollbar for Firefox */
}

.cctv-grid::-webkit-scrollbar {
  display: none; /* Hides scrollbar for Chrome, Safari */
}

.cctv-frame {
  flex: 1 1 auto;
  width: 100%; /* Ensures equal distribution */
  max-width: 100%;
  height: 29vh;
  border: none;
}

  </style>
  